module.exports = __webpack_public_path__ + "static/img/accountLevel.88addce7.png";